import { render, staticRenderFns } from "./JdsTimeline.vue?vue&type=template&id=7f483a7e&scoped=true&"
import script from "./JdsTimeline.vue?vue&type=script&lang=ts&"
export * from "./JdsTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f483a7e",
  null
  
)

export default component.exports